import { useState, useCallback } from 'react';
import profileService, { ProfileSearchServiceError } from '../services/profileService';
import { ProfileSearchResponse } from '../types/profile';

export function useProfileSearch() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [profile, setProfile] = useState<ProfileSearchResponse | null>(null);

  const searchProfile = async (run: string, token: string) => {
    setLoading(true);
    setError(null);
    setProfile(null);

    try {
      const result = await profileService.searchProfileByRun(run, token);
      setProfile(result);
    } catch (err) {
      if (err instanceof ProfileSearchServiceError) {
        if (err.statusCode === 404) {
          setError('Usuario no encontrado');
        } else {
          setError(err.message);
        }
      } else {
        setError('Error de búsqueda');
      }
      throw err; // Re-throw to allow caller to handle
    } finally {
      setLoading(false);
    }
  };

  const clearResults = useCallback(() => {
    setProfile(null);
    setError(null);
  }, []);

  return {
    profile,
    loading,
    error,
    searchProfile,
    clearResults
  };
}